const palette = {
    primary: {
        //main: '#4F5D75',
        main: '#A24800',
    },
    secondary: {
        main: '#4648A1',
        light:'#99a5bd',
    },
    success: {
        main: '#2FCA74',
    },
    error: {
        main: '#B03524',
    },
    danger: {
        main: '#a83232',
    },
    info: {
        main: '#006581',
    },
    warning: {
        main: '#b698ef',
    },
    dark: {
        main: '#282F37',
    },
    coolGrey: {
        main: '#878c91',
    },
    coldGrey: {
        main: '#dde1eb',
    },
    text: {
        primary: '#252529',
        secondary: 'rgba(118, 128, 147, 1)',
        disabled: 'rgba(0, 0, 0, 0.38)',
        hint: 'rgba(0, 0, 0, 0.38)',
    },
};
export default palette;
